// Client mirror of supabase/functions/_shared/aestheticEnums.ts.
// Keep in sync with the edge version.

export const FORMALITY_LEVELS = [
  "casual",
  "smart casual",
  "business casual",
  "formal",
  "dressy",
] as const;
export type Formality = (typeof FORMALITY_LEVELS)[number];

export const OCCASION_TAGS = [
  "everyday",
  "casual_daytime",
  "smart_casual",
  "workwear",
  "going_out",
  "evening",
  "formal_event",
  "athleisure",
  "loungewear",
  "vacation",
  "beach",
  "wedding_guest",
  "date_night",
] as const;
export type OccasionTag = (typeof OCCASION_TAGS)[number];

const FORMALITY_SET = new Set<string>(FORMALITY_LEVELS);
const OCCASION_SET = new Set<string>(OCCASION_TAGS);

export function normaliseFormality(value: unknown): Formality | null {
  if (typeof value !== "string") return null;
  const v = value.trim().toLowerCase();
  return FORMALITY_SET.has(v) ? (v as Formality) : null;
}

const OCCASION_MAP: Record<string, OccasionTag> = {
  everyday: "everyday",
  daily: "everyday",
  weekend: "casual_daytime",
  casual: "casual_daytime",
  "casual daytime": "casual_daytime",
  brunch: "casual_daytime",
  "smart casual": "smart_casual",
  work: "workwear",
  office: "workwear",
  workwear: "workwear",
  business: "workwear",
  "business casual": "workwear",
  "going out": "going_out",
  drinks: "going_out",
  bar: "going_out",
  party: "going_out",
  nightlife: "going_out",
  evening: "evening",
  dinner: "evening",
  "evening out": "evening",
  formal: "formal_event",
  "formal event": "formal_event",
  gala: "formal_event",
  athleisure: "athleisure",
  gym: "athleisure",
  workout: "athleisure",
  lounge: "loungewear",
  loungewear: "loungewear",
  home: "loungewear",
  vacation: "vacation",
  holiday: "vacation",
  travel: "vacation",
  resort: "vacation",
  beach: "beach",
  pool: "beach",
  wedding: "wedding_guest",
  "wedding guest": "wedding_guest",
  date: "date_night",
  "date night": "date_night",
};

export function mapOccasionToTag(value: unknown): OccasionTag | null {
  if (typeof value !== "string") return null;
  const v = value.trim().toLowerCase();
  if (!v) return null;
  const underscored = v.replace(/\s+/g, "_");
  if (OCCASION_SET.has(underscored)) return underscored as OccasionTag;
  return OCCASION_MAP[v] ?? null;
}
